import { IconWrapper } from './IconWrapper'
import { IIconProps } from './props'

export function FixedPhoneIcon(props: IIconProps) {
  return (
    <IconWrapper {...props}>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_18166_40105)">
          <path
            d="M12.843 11.3549C12.9295 11.2973 13.0291 11.2622 13.1326 11.2528C13.2362 11.2433 13.3404 11.2599 13.4359 11.3009L17.1203 12.9517C17.2445 13.0048 17.3481 13.0967 17.4157 13.2135C17.4833 13.3304 17.5112 13.4661 17.4953 13.6002C17.3739 14.5072 16.9273 15.3393 16.2383 15.9418C15.5494 16.5442 14.6652 16.8759 13.75 16.8752C10.9321 16.8752 8.22957 15.7557 6.23699 13.7632C4.24442 11.7706 3.125 9.06809 3.125 6.25017C3.1243 5.33501 3.456 4.45075 4.05841 3.76183C4.66082 3.07291 5.49293 2.62623 6.4 2.50485C6.53409 2.48892 6.66973 2.51685 6.78662 2.58445C6.90351 2.65205 6.99537 2.75569 7.04844 2.87985L8.69922 6.56735C8.73978 6.66206 8.7563 6.76533 8.7473 6.86797C8.7383 6.9706 8.70407 7.06942 8.64766 7.15563L6.97813 9.14079C6.9189 9.23015 6.88388 9.33335 6.87649 9.4403C6.86909 9.54725 6.88958 9.65429 6.93594 9.75095C7.58203 11.0736 8.94922 12.4244 10.2758 13.0642C10.373 13.1104 10.4805 13.1304 10.5878 13.1223C10.695 13.1142 10.7983 13.0783 10.8875 13.0181L12.843 11.3549Z"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_18166_40105">
            <rect width="20" height="20" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </IconWrapper>
  )
}
